import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { getImgixUrl } from '../../../../helpers';
import { withBrand } from '../../../../providers/BrandProvider';
import Link from '../../../shared/Link/Link';
import Carousel from '../../../shared/Carousel/Carousel';
import PersonContentCarouselArrow from '../PersonContentCarouselArrow/PersonContentCarouselArrow';
import './PersonContentCarousel.scss';

export class PersonContentCarousel extends Component {
  static propTypes = {
    slides: PropTypes.array,
    currentPersonPath: PropTypes.string,
    brand: PropTypes.object,
  };

  constructor(props) {
    super(props);

    let activeSlide = props.slides
      .map((slide) => slide.path)
      .indexOf(props.currentPersonPath);

    this.slides = props.slides.filter(
      (slide) => slide.path !== props.currentPersonPath,
    );

    if (!this.slides[activeSlide]) {
      activeSlide = 0;
    }

    this.state = {
      activeSlide,
    };

    this.carouselSettings = {
      dots: false,
      fade: true,
      initialSlide: this.state.activeSlide,
      prevArrow: (
        <PersonContentCarouselArrow
          slides={this.slides}
          tenantId={this.props.pageConfig.tenantId}
          t={this.props.t}
          isPrevSlide
        />
      ),
      nextArrow: (
        <PersonContentCarouselArrow
          slides={this.slides}
          tenantId={this.props.pageConfig.tenantId}
          t={this.props.t}
          isPrevSlide={false}
        />
      ),
      beforeChange: (current, next) => {
        setTimeout(() => {
          this.setState({ activeSlide: next });
        }, 10);
      },
    };
  }

  render() {
    const { brand, pageConfig: { tenantId } = {} } = this.props;

    const current = this.slides[this.state.activeSlide];
    const {
      displayHonorific,
      honorific,
      forename,
      surname,
      middleName = '',
    } = current;

    return (
      <div className="person-content-carousel">
        <Carousel embedSettings={this.carouselSettings}>
          {this.slides.map((slide, i) => {
            const backgroundImage = getImgixUrl(
              tenantId,
              slide.photo?.path,
              'fit=clamp&w=120&h=120',
              '/images/default-silhouette.png',
            );

            return (
              <div key={i} className="person-content-carousel__item-wrapper">
                <Link to={`/speakers/${current.path}`} event>
                  <div
                    className="person-content-carousel__item lazy"
                    data-background-image={backgroundImage}
                  />
                </Link>
              </div>
            );
          })}
        </Carousel>
        <div className="person-content-carousel__item-text">
          <Link
            to={`/speakers/${current.path}`}
            event
            className="person-content-carousel__item-link"
            style={{ color: brand.secondaryColor }}
          >
            <div
              className="person-content-carousel__item-name"
              data-testid="person-content-carousel-name"
            >
              {displayHonorific && honorific} {forename} {middleName} {surname}
            </div>
            <div className="person-content-carousel__item-job">
              {current.jobTitle}
            </div>
            <div className="person-content-carousel__item-company">
              {current.company}
            </div>
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageConfig: state.pageConfig,
  };
}

export default withTranslation()(
  connect(mapStateToProps)(withBrand(PersonContentCarousel)),
);
